import React from 'react';

// PRD-031 F1.3 — the product renders NO emoji or pictographic glyphs.
// Status semantics ride styled chips with plain words; where a small icon
// genuinely helps, it is one of these inline SVGs (aria-hidden — the
// adjacent text carries the meaning).

export function CloseIcon({ size = 12 }) {
  return (
    <svg aria-hidden width={size} height={size} viewBox="0 0 12 12" fill="none">
      <path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

export function CheckIcon({ size = 11 }) {
  return (
    <svg aria-hidden width={size} height={size} viewBox="0 0 12 12" fill="none">
      <path d="M1.8 6.4l3 3 5.4-6.6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function WarnIcon({ size = 12 }) {
  return (
    <svg aria-hidden width={size} height={size} viewBox="0 0 12 12" fill="none">
      <path d="M6 1.2 11 10.4H1z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
      <path d="M6 4.6v2.6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <circle cx="6" cy="8.9" r=".7" fill="currentColor" />
    </svg>
  );
}

export function DotIcon({ size = 7 }) {
  return (
    <svg aria-hidden width={size} height={size} viewBox="0 0 8 8">
      <circle cx="4" cy="4" r="3.2" fill="currentColor" />
    </svg>
  );
}

export function ChevronIcon({ size = 9 }) {
  return (
    <svg aria-hidden width={size} height={size + 2} viewBox="0 0 7 11" fill="none">
      <path d="M1.4 1.2 5.6 5.5 1.4 9.8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
